// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HdhKv","tagline":"styles_tagline__Y0bP3"};